import { Component, Input, OnInit, HostListener } from '@angular/core';
import { AlertController, MenuController,LoadingController, ModalController,AnimationController, Platform } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-warehouse-list',
  templateUrl: './warehouse-list.component.html',
  styleUrls: ['./warehouse-list.component.scss'],
})
export class WarehouseListComponent  implements OnInit {
  
  warehouse_list:any = [];
  @Input() type;

  constructor(public modalCtrl: ModalController,public db:DataService) { } 

  ngOnInit() {
   this.get_warehouse();

   const modalState = {
    modal : true,
    desc : 'fake state for our modal'
  };
  history.pushState(modalState, '');

}

@HostListener('window:popstate', ['$event'])
dismissModal() {
  this.modalCtrl.dismiss();
}
  
  get_warehouse(){
    let data = {};
    this.db.get_centre_list(data).subscribe(res=>{
      if(res && res.message.status == "Success"){

        if(this.type && this.type == 'filters'){
          this.warehouse_list.push({'label':'All','value':'All'});
          this.warehouse_list = [...this.warehouse_list,...res.message.data];
          this.get_check_filters();
        }else{
          this.warehouse_list = res.message.data;
          this.get_check();

        }
      }
    })
  }

  get_check(){
    if(this.db.centres_list.length != 0){
      this.warehouse_list.map(res=>{
        this.db.centres_list.map(r=>{
          if(r.center == res.value){
            res['isActive'] = true;
          }
        })
      })
    }
  }


  get_check_filters(){
    if(this.db.centre){
      this.warehouse_list.map(res=>{
          if(this.db.centre == res.value){
            res['isActive'] = true;
          }
      })
    }
  }


  // on_click_select
  // add_warehous(selected_item){
  //   this.warehouse_list.map(res=>{
  //      if(selected_item.value == res.value){
  //       res['isActive'] = res['isActive'] ? false : true;
  //       if(res['isActive']){
  //         this.db.centres_list.push({'center':res.value});
  //       }else{
  //         this.db.centres_list = this.db.centres_list.filter(r=>{return  r.center != selected_item.value})
  //       }
  //      }
  //   })
  // }

  add_warehous(selected_item){
    this.warehouse_list.map(res=>{
       if(selected_item.value == res.value){
        res['isActive'] = res['isActive'] ? false : true;
       }
    })
  }

  add(selected_item){
    this.warehouse_list.map(res=>{
       if(selected_item.value == res.value){
        res['isActive'] = true;
        let data = {'status': 'success','data':selected_item};
        this.modalCtrl.dismiss(data);
       }else{
        res['isActive'] = false;
       }
    })
  }

  select_all(array_list){
    let array:any = [];
    array_list.map(res=>{
      res['isActive'] = true;
      array.push({'center':res.value});
    })
    this.db.centres_list = array;
    this.db.alert_animate.next(this.db.centres_list.length + ' centres selected')
    let data = {'status': 'success','data':this.db.centres_list}
    this.modalCtrl.dismiss(data);
  }

  save(){

    let list = this.warehouse_list.filter(r=>{return r['isActive'] == true})
    console.log(list);
    if(list.length == 0){
      this.db.alert('Please select any of centre');
    }else{
      this.db.centres_list = [];
      list.map(res=>{
        this.db.centres_list.push({'center':res.value});
      })
      this.db.alert_animate.next(this.db.centres_list.length + ' centres selected');
      let data = {'status': 'success','data':this.db.centres_list}
      this.modalCtrl.dismiss(data);
    }
  }

  close_modal(){
    // this.db.centres_list = [];
    this.modalCtrl.dismiss();
  }
}
